var CalendarType;
(function (CalendarType) {
  // expandable to have other types of calendar
  CalendarType["hhn"] = "hhn-event";
  CalendarType["blockout"] = "blockout-date";
})(CalendarType || (CalendarType = {}));

export { CalendarType as C };

